import React from 'react';
import {
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  Stack,
  Box
} from '@mui/material';
import {
  Devices as DevicesIcon,
  Settings as SettingsIcon,
  Monitor as MonitorIcon,
  Link as LinkIcon,
  Update as UpdateIcon,
  Analytics as AnalyticsIcon,
  Add as AddIcon
} from '@mui/icons-material';

const DeviceFeatures = ({ onRegisterDevice }) => {
  const deviceFeatures = [
    { 
      icon: <SettingsIcon fontSize="small" />, 
      title: 'Device Registration', 
      desc: 'Register and configure devices', 
      action: onRegisterDevice 
    },
    { 
      icon: <MonitorIcon fontSize="small" />, 
      title: 'Status Monitoring', 
      desc: 'Real-time device health tracking' 
    },
    { 
      icon: <LinkIcon fontSize="small" />, 
      title: 'Network Binding', 
      desc: 'Bind devices to networks' 
    },
    { 
      icon: <UpdateIcon fontSize="small" />, 
      title: 'Version Tracking', 
      desc: 'Software and firmware management' 
    },
    { 
      icon: <AnalyticsIcon fontSize="small" />, 
      title: 'Analytics', 
      desc: 'Device statistics and insights' 
    }
  ];

  return (
    <Paper sx={{ p: 3, borderRadius: 1, bgcolor: 'grey.50' }}>
      <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
        <DevicesIcon fontSize="small" color="primary" />
        <Typography variant="h6" fontWeight={600}>
          Device Management
        </Typography>
      </Stack>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Advanced device management capabilities
      </Typography>

      <Grid container spacing={2}>
        {deviceFeatures.map((feature, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card 
              variant="outlined" 
              sx={{ 
                borderRadius: 1,
                transition: 'all 0.2s ease',
                cursor: feature.action ? 'pointer' : 'default',
                '&:hover': { 
                  borderColor: 'primary.main',
                  boxShadow: 1,
                  transform: feature.action ? 'translateY(-2px)' : 'none'
                }
              }}
              onClick={feature.action}
            >
              <CardContent sx={{ p: 2 }}>
                <Stack direction="row" alignItems="flex-start" spacing={1.5}>
                  <Box sx={{ color: 'primary.main', mt: 0.25 }}>
                    {feature.icon}
                  </Box>
                  <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 0.5 }}>
                      {feature.title}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.4 }}>
                      {feature.desc}
                    </Typography>
                  </Box>
                  {feature.action && (
                    <AddIcon fontSize="small" color="primary" />
                  )}
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default DeviceFeatures; 